export const pageRegex = [
  { regex: /^\/(tr\/)?blog(\/(category\/[^\/]+|[^\/]+)?)?\/?$/, page: "Blog" },
  {
    regex:
      /^\/tr\/(hazirlik\/[^\/]+\/|konular\/[^\/]+(\/[^\/]+){0,2}\/|dersler\/[^\/]+\/|sinavlar\/[^\/]+\/|siniflar\/[^\/]+\/)$/,
    page: "Learning",
  },
  {
    regex:
      /^\/(tr\/sorular(\/[^\/]+(\/[^\/]+)?)?|tr\/soru-cozum\/[^\/]+|questions(\/[^\/]+(\/[^\/]+)?)?|questions-and-answers\/[^\/]+)\/?$/,
    page: "Question Indexing",
  },
  { regex: /^\/(tr\/paketler(\/[^\/]+)?|plans)\/?$/, page: "Packages" },
  { regex: /^\/(tr\/)?u\/.*$/, page: "Dashboard" },
  { regex: /^\/(tr)?\/auth\/.*$/, page: "Auth" },
  {
    regex:
      /^\/(tr|en-AE)?\/(yks-puan-hesaplama|lgs-puan-hesaplama|sinav-sonuc|uygulama-indir|download-app)\//,
    page: "Utilities",
  },
  { regex: /.*checkout.*/i, page: "Checkout" },
  {
    regex:
      /^\/(?:tr\/(?:lisans|partner|basla)|basla(?:\/redeem)?|licenseCode|redeem)(?:\/.*)?$/,
    page: "License Activation",
  },
  {
    regex:
      /^(\/tr\/gizlilik-ilkeleri|\/privacy-policy|\/terms-of-use|\/tr\/kvkk|\/tr\/iletisim-izinleri-yonetmeligi|\/tr\/ticari-iletisim-riza-metni|\/tr\/kullanim-kosullari)(\/.*)?$/,
    page: "Legal",
  },
  {
    regex:
      /^(\/tr\/hakkimizda|\/tr\/iletisim|\/tr\/sss|\/faq|\/about-us|\/contact-us|\/en-us\/about-us|\/en-ae\/about-us)(\/.*)?$/,
    page: "About",
  },
  {
    regex:
      /^(\/|\/tr\/?|\/en-ae\/?|\/en-us\/?|\/tr\/egitmen\/?|\/tr\/veli\/?|\/tr\/okul\/?|\/en\/?|\/en-AE\/?|\/en-AE\/early-access\/?)$/,
    page: "Landing",
  },
  { regex: /^\/tr\/kurumsal-deneme-sinavlari\/$/, page: "Features" },
];
